import React from "react";
import {  Navigate } from "react-router-dom";
import authService from "./authService.js";


function ProtectedRoute({ children, roles, ...rest }) {
  if (authService.isAuthenticateduser()) {
    // console.log("Checkkk")
    const userRoles = authService.getCurrentUserRole();
    // console.log("Checkkk 11111")
    
    if(
      (roles !== undefined || roles !== null || roles !== "") &&
      userRoles !== null
    ) {
      if (roles.includes(userRoles) && authService.isAuthenticateduser()) {
        // console.log("Checkkk 222222")
        return children;
      } else {
        // console.log("Checkkk 33333")
        return <Navigate to="/login"  replace />;
      }
    } else {
      // console.log("Checkkk 44444444")
      return <Navigate to="/login" replace />;
    }
  } else {
    // console.log("Checkkk 5555555555")
    return <Navigate to="/login" replace />;
  }
}

export default ProtectedRoute;
